document.addEventListener('DOMContentLoaded', () => {
  inviewTracking()
  clickTracking()
})

// .js-gtm-inview-sender が viewport に出現したら GTM にイベントを飛ばす
// data-event-category, data-event-action, data-event-label で属性を指定する
function inviewTracking() {
  const onInview = (entries: IntersectionObserverEntry[]) => {
    entries.forEach(entry => {
      if (entry.isIntersecting === false) {
        return
      }

      const target = entry.target as HTMLElement
      const eventAction = target.dataset.eventAction
        ? target.dataset.eventAction
        : '閲覧'

      dataLayer.push({
        event: target.dataset.eventCategory,
        'event action': eventAction,
        'event label': target.dataset.eventLabel
      })
      inviewObserverForGtm.unobserve(target)
    })
  }

  const inviewObserverForGtm = new IntersectionObserver(onInview)

  document.querySelectorAll('.js-gtm-inview-sender').forEach(element => {
    inviewObserverForGtm.observe(element)
  })
}

// .js-gtm-click-sender もしくはそれの子要素がクリックされたら GTM にイベントを飛ばす
// data-event-category, data-event-action, data-event-label で属性を指定する
function clickTracking() {
  document.querySelectorAll('.js-gtm-click-sender').forEach(element => {
    element.addEventListener('click', sendClick)
    element.addEventListener('mousedown', (evt: MouseEvent) => {
      // for middle button
      if (evt.button === 1) {
        sendClick(evt)
      }
    })
  })
}

function sendClick(evt) {
  const target = evt.currentTarget as HTMLElement

  const eventAction = target.dataset.eventAction
    ? target.dataset.eventAction
    : 'クリック'

  const data = {
    event: target.dataset.eventCategory,
    'event action': eventAction,
    'event label': target.dataset.eventLabel
  }
  dataLayer.push(data)
}
